import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import AdminFormModal from '../shared/AdminFormModal';

const AddAreaModal = ({ show, onClose, onAreaAdded }) => {
  const [name, setName] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    onAreaAdded({ name });
    setName('');
    onClose();
  };

  return (
    <AdminFormModal
      show={show}
      onClose={onClose}
      title="Yeni Alan Ekle"
      subtitle="Servis organizasyonunu bölmek için yeni bir çalışma alanı tanımlayın."
      icon={faPlus}
      footer={(
        <>
          <div className="admin-modal-footer-secondary">
            <Button variant="secondary" onClick={onClose} className="modal-cancel-btn">
              İptal
            </Button>
          </div>
          <div className="admin-modal-footer-primary">
            <Button variant="primary" onClick={handleSubmit} className="modal-save-btn">
              <FontAwesomeIcon icon={faPlus} />
              Alan Ekle
            </Button>
          </div>
        </>
      )}
    >
      <Form onSubmit={handleSubmit} className="admin-form-section">
        <div className="admin-form-block">
          <div className="admin-form-block-title">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            Alan Bilgisi
          </div>
          <div className="admin-modal-field">
            <Form.Label>Alan Adı</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(event) => setName(event.target.value)}
              className="form-input"
              placeholder="Örn: Bahçe, Bar, VIP Salon"
              required
            />
            <div className="admin-modal-helper">Alan adı kullanıcı atamaları ve ürün görünürlüğü için kullanılır.</div>
          </div>
        </div>
      </Form>
    </AdminFormModal>
  );
};

export default AddAreaModal;
